import { Wrap } from './styles';

import InputBase from '@material-ui/core/InputBase';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { forwardRef, useState } from 'react';
import MaskedInput from 'react-text-mask';

/**
 * MaskedTextField
 * 
 * @param {boolean} initialActive
 * @param {object} inputProps
 * @param {*} props
 * @param {object} ref
 */
const MaskedTextField = forwardRef(
  ({ initialActive, inputProps, ...props }, ref) => {
    // o input está ativo se estiver focado ou com conteúdo
    const [inputIsActive, setInputIsActive] = useState(initialActive || false);

    return (
      <Wrap ref={ref} inputIsActive={inputIsActive}>
        {props.label ? <label htmlFor={props.name}>{props.label}</label> : null}
        <MaskedInput
          mask={props.mask}
          placeholder={props.placeholder}
          id={props.name}
          {...props}
          render={(fwrdRef, fwrdProps) => (
            <InputBase
              inputRef={fwrdRef}
              {...fwrdProps}
              inputProps={inputProps}
              onFocus={(e) => {
                if (fwrdProps.onFocus) fwrdProps.onFocus(e);
                setInputIsActive(true);
              }}
              onBlur={(e) => {
                if (fwrdProps.onBlur) fwrdProps.onBlur(e);
                if (!e.target.value) setInputIsActive(false);
              }}
            />
          )}
        />
        {props.error && props.helperText ? (
          <div className="error">{props.helperText}</div>
        ) : null}
      </Wrap>
    );
  }
);

export default MaskedTextField;
